/* istanbul ignore file */

import { FORM_FIELDS } from './form-fields';

export const FORM_PATHS = {
  HEADLINE: () => FORM_FIELDS.HEADLINE,
  STANDFIRST: () => FORM_FIELDS.STANDFIRST,
  LANGUAGE: () => FORM_FIELDS.LANGUAGE,
  CONTENT_BODY: () => FORM_FIELDS.CONTENT_BODY,
  BODY: () => `${FORM_FIELDS.CONTENT_BODY}.${FORM_FIELDS.BODY}`,
  IMGS: () => `${FORM_FIELDS.CONTENT_BODY}.${FORM_FIELDS.IMGS}`,
  VIDEOS: () => `${FORM_FIELDS.CONTENT_BODY}.${FORM_FIELDS.VIDEOS}`,
  WEBSITES: () => FORM_FIELDS.WEBSITES,
  INTERNAL_INFORMATION: () => FORM_FIELDS.INTERNAL_INFORMATION,
  LIVE_URLS: () =>
    `${FORM_FIELDS.INTERNAL_INFORMATION}.${FORM_FIELDS.LIVE_URLS}`,
  CONTENT_IDS: () =>
    `${FORM_FIELDS.INTERNAL_INFORMATION}.${FORM_FIELDS.CONTENT_IDS}`,
  ARTICLE_VERSION_LIST: () => FORM_FIELDS.ARTICLE_VERSION_LIST,
  NEXT_STATES: () => FORM_FIELDS.NEXT_STATES,
};
